import React from 'react';
import { IMG } from '../../Commons/Functions';

function TopCardImage({ deck, playerId, topCardHiddenTo, gameData }) {
    if (!deck.length || !playerId) return;
    const topCard = deck[deck.length - 1];
    const hidden = topCardHiddenTo[playerId] === true;

    return (
        <div className={"top-card position-absolute top-0 start-0 w-100 h-100" + (hidden ? " hidden" : "")}> 
            <IMG id={topCard.id + "-images"} className="position-absolute top-0 start-0 w-100 h-100" src={topCard.cardData.face.front.image} />
        </div>
    );
};

function areEqual(prevProps, nextProps) {
    console.log(prevProps, nextProps)
    return true;
}

//export default React.memo(TopCardImage, areEqual);
// Add memo back later
export default TopCardImage;